// Actions
export const INDEX_REQUEST: string = "Deliveries/INDEX_REQUEST";
export const INDEX_SUCCESS: string = "Deliveries/INDEX_SUCCESS";
export const INDEX_FAILURE: string = "Deliveries/INDEX_FAILURE";

export const SHOW_REQUEST: string = "Deliveries/SHOW_REQUEST";
export const SHOW_SUCCESS: string = "Deliveries/SHOW_SUCCESS";
export const SHOW_FAILURE: string = "Deliveries/SHOW_FAILURE";

export const RESET_FILTERS: string = "Deliveries/RESET_FILTERS";
export const SET_FILTERS: string = "Deliveries/SET_FILTERS";
